
export default {
  data() {
    return {
      startAnimation: false,
    };
  },
  watch: {
    $route() {
      if (
        document.readyState === "complete" ||
        document.readyState === "interactive"
      ) {
        this.startAnimation = true;
      }
    },
  },
};
